module.exports = __webpack_public_path__ + "img/icon_phone.5f3b5152.webp";